import { StatementType } from '@/types/services';

const enable = 'enable';

export const esiaUrlEdit = process.env.VUE_APP_URL_ESIA;
export const configSigning = process.env.VUE_APP_SIGNING === enable;
export const configSigningAdditionalSigners =
  process.env.VUE_APP_SIGNING_ADDITIONAL_SIGNERS === enable;

export const configRegionsCode = process.env.VUE_APP_NA_NOTICE_REGIONS_CODE;

export const configNotarialWritCodeNR =
  process.env.VUE_APP_NA_NOTICE_NOTARIAL_WRIT_CODE;

export const statementTypeToNAEnabled = {
  [StatementType.NOTICE_RECOVERY]:
    process.env.VUE_APP_NA_NOTICE_RECOVERY === enable,

  [StatementType.RUZDI]: process.env.VUE_APP_NA_RUZDI === enable,

  [StatementType.SECURING_EVIDENCE]:
    process.env.VUE_APP_NA_SECURING_EVIDENCE === enable,

  [StatementType.TRANSFER_EL_DOCS]:
    process.env.VUE_APP_NA_TRANSFER_EL_DOCS === enable,

  [StatementType.CORRECT_TRANSLATION]:
    process.env.VUE_APP_NA_CORRECT_TRANSLATION === enable,

  [StatementType.ACCEPTANCE_DEPOSIT]:
    process.env.VUE_APP_NA_ACCEPTANCE_DEPOSIT === enable,

  [StatementType.ACCEPTANCE_ESCROW]:
    process.env.VUE_APP_NA_ACCEPTANCE_ESCROW === enable,

  [StatementType.DOCUMENT_CONVERSION]:
    process.env.VUE_APP_NA_DOCUMENT_CONVERSION === enable,

  [StatementType.STORAGE_ACCEPT]:
    process.env.VUE_APP_NA_STORAGE_ACCEPT === enable,

  [StatementType.STORAGE_ISSUE]:
    process.env.VUE_APP_NA_STORAGE_ISSUE === enable,

  [StatementType.ROD]: process.env.VUE_APP_NA_ROD === enable,
  [StatementType.EXTRACTION_ROD]:
    process.env.VUE_APP_NA_EXTRACTION_ROD === enable,
  [StatementType.EGRN_CONFIRM]: process.env.VUE_APP_NA_EGRN_CONFIRM === enable,
};

export const statementTypeToIsTestMode = {
  [StatementType.NOTICE_RECOVERY]:
    process.env.VUE_APP_TEST_NOTICE_RECOVERY === enable,

  [StatementType.RUZDI]: process.env.VUE_APP_TEST_RUZDI === enable,

  [StatementType.SECURING_EVIDENCE]:
    process.env.VUE_APP_TEST_SECURING_EVIDENCE === enable,

  [StatementType.TRANSFER_EL_DOCS]:
    process.env.VUE_APP_TEST_TRANSFER_EL_DOCS === enable,

  [StatementType.ACCEPTANCE_ESCROW]:
    process.env.VUE_APP_TEST_ACCEPTANCE_ESCROW === enable,

  [StatementType.ACCEPTANCE_DEPOSIT]:
    process.env.VUE_APP_TEST_ACCEPTANCE_DEPOSIT === enable,

  [StatementType.CORRECT_TRANSLATION]:
    process.env.VUE_APP_TEST_CORRECT_TRANSLATION === enable,

  [StatementType.STORAGE_ACCEPT]:
    process.env.VUE_APP_TEST_STORAGE_ACCEPT === enable,
  [StatementType.STORAGE_ISSUE]:
    process.env.VUE_APP_TEST_STORAGE_ISSUE === enable,

  [StatementType.DOCUMENT_CONVERSION]:
    process.env.VUE_APP_TEST_DOCUMENT_CONVERSION === enable,

  [StatementType.ROD]: false,
  [StatementType.EXTRACTION_ROD]: false,
  [StatementType.EGRN_CONFIRM]:
    process.env.VUE_APP_TEST_EGRN_CONFIRM === enable,
};

// Альтернативный сценарий "Отзыв"; enable - показать кнопку; disable -скрыть кнопку;
export const statementTypeToIsWithdrawn = {
  [StatementType.NOTICE_RECOVERY]:
    process.env.VUE_APP_WITHDRAWN_NOTICE_RECOVERY === enable,

  [StatementType.RUZDI]: process.env.VUE_APP_WITHDRAWN_RUZDI === enable,

  [StatementType.SECURING_EVIDENCE]:
    process.env.VUE_APP_WITHDRAWN_SECURING_EVIDENCE === enable,

  [StatementType.TRANSFER_EL_DOCS]:
    process.env.VUE_APP_WITHDRAWN_TRANSFER_EL_DOCS === enable,

  [StatementType.CORRECT_TRANSLATION]:
    process.env.VUE_APP_WITHDRAWN_CORRECT_TRANSLATION === enable,

  [StatementType.ACCEPTANCE_DEPOSIT]:
    process.env.VUE_APP_WITHDRAWN_ACCEPTANCE_DEPOSIT === enable,

  [StatementType.ACCEPTANCE_ESCROW]:
    process.env.VUE_APP_WITHDRAWN_ACCEPTANCE_ESCROW === enable,

  [StatementType.STORAGE_ACCEPT]:
    process.env.VUE_APP_WITHDRAWN_STORAGE_ACCEPT === enable,

  [StatementType.STORAGE_ISSUE]:
    process.env.VUE_APP_WITHDRAWN_STORAGE_ISSUE === enable,

  [StatementType.DOCUMENT_CONVERSION]:
    process.env.VUE_APP_WITHDRAWN_DOCUMENT_CONVERSION === enable,

  [StatementType.ROD]: false,
  [StatementType.EXTRACTION_ROD]:
    process.env.VUE_APP_WITHDRAWN_EXTRACTION_ROD === enable,
  [StatementType.EGRN_CONFIRM]:
    process.env.VUE_APP_WITHDRAWN_EGRN_CONFIRM === enable,
};

// Альтернативный сценарий "Смена округа"; enable - показать кнопку; disable -скрыть кнопку;
export const statementTypeToIsDistrict = {
  [StatementType.NOTICE_RECOVERY]:
    process.env.VUE_APP_DISTRICT_NOTICE_RECOVERY === enable,

  [StatementType.RUZDI]: process.env.VUE_APP_DISTRICT_RUZDI === enable,

  [StatementType.SECURING_EVIDENCE]:
    process.env.VUE_APP_DISTRICT_SECURING_EVIDENCE === enable,

  [StatementType.TRANSFER_EL_DOCS]:
    process.env.VUE_APP_DISTRICT_TRANSFER_EL_DOCS === enable,

  [StatementType.CORRECT_TRANSLATION]:
    process.env.VUE_APP_DISTRICT_CORRECT_TRANSLATION === enable,

  [StatementType.ACCEPTANCE_DEPOSIT]:
    process.env.VUE_APP_DISTRICT_ACCEPTANCE_DEPOSIT === enable,

  [StatementType.ACCEPTANCE_ESCROW]:
    process.env.VUE_APP_DISTRICT_ACCEPTANCE_ESCROW === enable,

  [StatementType.STORAGE_ACCEPT]:
    process.env.VUE_APP_DISTRICT_STORAGE_ACCEPT === enable,
  [StatementType.STORAGE_ISSUE]:
    process.env.VUE_APP_DISTRICT_STORAGE_ISSUE === enable,

  [StatementType.DOCUMENT_CONVERSION]:
    process.env.VUE_APP_DISTRICT_DOCUMENT_CONVERSION === enable,

  [StatementType.ROD]: false,
  [StatementType.EXTRACTION_ROD]:
    process.env.VUE_APP_DISTRICT_EXTRACTION_ROD === enable,
  [StatementType.EGRN_CONFIRM]:
    process.env.VUE_APP_DISTRICT_EGRN_CONFIRM === enable,
};

// Альтернативный сценарий "Передача дополнительных документов"; enable - показать кнопку; disable -скрыть кнопку;
export const isEnvAddDocumentsEnable = {
  [StatementType.NOTICE_RECOVERY]:
    process.env.VUE_APP_ADDITIONAL_DOCUMENTS_NOTICE_RECOVERY === enable,

  [StatementType.RUZDI]:
    process.env.VUE_APP_ADDITIONAL_DOCUMENTS_RUZDI === enable,

  [StatementType.SECURING_EVIDENCE]:
    process.env.VUE_APP_ADDITIONAL_DOCUMENTS_SECURING_EVIDENCE === enable,

  [StatementType.TRANSFER_EL_DOCS]:
    process.env.VUE_APP_ADDITIONAL_DOCUMENTS_TRANSFER_EL_DOCS === enable,

  [StatementType.CORRECT_TRANSLATION]:
    process.env.VUE_APP_ADDITIONAL_DOCUMENTS_CORRECT_TRANSLATION === enable,

  [StatementType.ACCEPTANCE_DEPOSIT]:
    process.env.VUE_APP_ADDITIONAL_DOCUMENTS_ACCEPTANCE_DEPOSIT === enable,

  [StatementType.ACCEPTANCE_ESCROW]:
    process.env.VUE_APP_ADDITIONAL_DOCUMENTS_ACCEPTANCE_ESCROW === enable,

  [StatementType.STORAGE_ACCEPT]:
    process.env.VUE_APP_ADDITIONAL_DOCUMENTS_STORAGE_ACCEPT === enable,

  [StatementType.STORAGE_ISSUE]:
    process.env.VUE_APP_ADDITIONAL_DOCUMENTS_STORAGE_ISSUE === enable,

  [StatementType.DOCUMENT_CONVERSION]:
    process.env.VUE_APP_ADDITIONAL_DOCUMENTS_DOCUMENT_CONVERSION === enable,

  [StatementType.ROD]: false,
  [StatementType.EXTRACTION_ROD]:
    process.env.VUE_APP_ADDITIONAL_DOCUMENTS_EXTRACTION_ROD === enable,
  [StatementType.EGRN_CONFIRM]:
    process.env.VUE_APP_ADDITIONAL_DOCUMENTS_EGRN_CONFIRM === enable,
};

const MrpaMode = {
  DISABLE: 'disable',
  FILE: 'file',
  GUID: 'guid',
};

export const isMapVisible = process.env.VUE_APP_MAP === enable;

export const notaryTariffDate = process.env.VUE_APP_NOTARY_TARIFF_DATE;

export const noticeRecoveryRegion = process.env.VUE_APP_DETECT_REGION === enable;

export const MrpaEnvs = {
  [StatementType.NOTICE_RECOVERY]:
    process.env.VUE_APP_MRPA_MODE_NOTICE_RECOVERY,
  [StatementType.RUZDI]: process.env.VUE_APP_MRPA_MODE_RUZDI,
  [StatementType.SECURING_EVIDENCE]:
    process.env.VUE_APP_MRPA_MODE_SECURING_EVIDENCE,
  [StatementType.TRANSFER_EL_DOCS]:
    process.env.VUE_APP_MRPA_MODE_TRANSFER_EL_DOCS,
  [StatementType.CORRECT_TRANSLATION]:
    process.env.VUE_APP_MRPA_MODE_CORRECT_TRANSLATION,
  [StatementType.ACCEPTANCE_DEPOSIT]:
    process.env.VUE_APP_MRPA_MODE_ACCEPTANCE_DEPOSIT,
  [StatementType.ACCEPTANCE_ESCROW]:
    process.env.VUE_APP_MRPA_MODE_ACCEPTANCE_ESCROW,
  [StatementType.DOCUMENT_CONVERSION]:
    process.env.VUE_APP_MRPA_MODE_DOCUMENT_CONVERSION,
  [StatementType.STORAGE_ACCEPT]: process.env.VUE_APP_MRPA_MODE_STORAGE_ACCEPT,
  [StatementType.STORAGE_ISSUE]: process.env.VUE_APP_MRPA_MODE_STORAGE_ISSUE,
  [StatementType.ROD]: process.env.VUE_APP_MRPA_MODE_ROD,
  [StatementType.EXTRACTION_ROD]: process.env.VUE_APP_MRPA_MODE_EXTRACTION_ROD,
  [StatementType.EGRN_CONFIRM]: process.env.VUE_APP_MRPA_MODE_EGRN_CONFIRM,
};

export const isMrpaEnable = (statementType) =>
  MrpaEnvs[statementType] !== MrpaMode.DISABLE;

export const isMrpaGuidEnable = (statementType) =>
  MrpaEnvs[statementType] === MrpaMode.GUID;

export const isMrpaFileEnable = (statementType) =>
  MrpaEnvs[statementType] === MrpaMode.FILE;

export const isNoticeRecoveryClassifierEnable = process.env.VUE_APP_NOTICE_RECOVERY_CLASSIFIER === enable
